var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveTopic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    viewBox: "0 0 19 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8328 5.99883L12.0366 0.202614C11.8284 -0.0405143 11.4625 -0.0688566 11.2193 0.139403C10.9762 0.347614 10.9479 0.713525 11.1561 0.956653C11.1756 0.979317 11.1967 1.00049 11.2193 1.01986L16.0244 5.83072H1.30421C0.984125 5.83072 0.724609 6.09023 0.724609 6.41037C0.724609 6.7305 0.984125 6.98997 1.30421 6.98997H16.0244L11.2193 11.795C10.9762 12.0032 10.9479 12.3691 11.1561 12.6122C11.3644 12.8554 11.7303 12.8837 11.9734 12.6755C11.996 12.656 12.0172 12.6349 12.0366 12.6122L17.8328 6.81603C18.0575 6.59004 18.0575 6.22492 17.8328 5.99883Z",
    fill: "#183243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveTopic);
export default __webpack_public_path__ + "static/media/move_topic.baaccde9b46b5dbc54c32ddc138f5e4c.svg";
export { ForwardRef as ReactComponent };